import Vue from 'vue';
import Toasted from 'vue-toasted';

const options = {
  position: 'top-center',
  type: 'success',
  duration: 2000,
  theme: 'bubble',
};
Vue.use(Toasted, options);
